module.exports = __webpack_public_path__ + "fonts/ProximaNovaA-Light.811fad439ae2afd7715c5ce52704ce11.ttf";